import axiosInstance from './axios';
import {chatAxiosInstance, axiosUploadInstance} from './axios';

// Crash Data APIs
export const getCrashData = ({ lat, lng, distance, startDate, endDate, page, limit }) =>
    axiosInstance.get('/crash-data', { params: { lat, lng, distance, startDate, endDate, page, limit } });

export const getCrashDataById = (id) => axiosInstance.get(`/crash-data/${id}`);

export const createCrashData = ({ timestamp, location, description }) =>
    axiosInstance.post('/crash-data', { timestamp, location, description });

export const updateCrashData = (id, { timestamp, location, description }) =>
    axiosInstance.put(`/crash-data/${id}`, { timestamp, location, description });

export const deleteCrashData = (id) => axiosInstance.delete(`/crash-data/${id}`);

// Incident APIs
export const getIncidents = ({ page=1, limit=10 }) => {
    return axiosInstance.get('/incidents', {
      params: { page, limit },
    });
  };
  

export const getIncidentById = (id) => axiosInstance.get(`/incidents/${id}`);

export const createIncident = ({ sourceType, sourceId, cameraFeedUrl, workflowId }) =>
    axiosInstance.post('/incidents', { sourceType, sourceId, cameraFeedUrl, workflowId });

export const updateIncident = (id, { sourceType, sourceId, cameraFeedUrl, workflowId }) =>
    axiosInstance.put(`/incidents/${id}`, { sourceType, sourceId, cameraFeedUrl, workflowId });

export const deleteIncident = (id) => axiosInstance.delete(`/incidents/${id}`);

export const searchIncidents = ({ startDate, endDate, page, limit, sourceType, sourceId, workflowId }) =>
    axiosInstance.get('/incidents/search', { 
        params: { startDate, endDate, page, limit, sourceType, sourceId, workflowId } 
    });


// Action APIs
export const getActions = ({ page, limit, search }) =>
    axiosInstance.get('/actions', { params: { page, limit, search } });

export const createAction = ({ name, type, details }) =>
    axiosInstance.post('/actions', { name, type, details });

export const updateAction = (id, { name, type, details }) =>
    axiosInstance.put(`/actions/${id}`, { name, type, details });

// Event APIs
export const getEvents = ({ page, limit, search }) =>
    axiosInstance.get('/events', { params: { page, limit, search } });

export const createEvent = ({ type, description }) =>
    axiosInstance.post('/events', { type, description });

// Workflow APIs
export const getWorkflows = ({ page, limit, search , assetId}) =>
    axiosInstance.get('/workflows', { params: { page, limit, search, assetId } });

export const getWorkflowById = (id) =>
    axiosInstance.get(`/workflows/${id}`);

export const createWorkflow = ({ name, description, type, assetType, assets, events, actions }) =>
    axiosInstance.post('/workflows', {
        name,
        description,
        type,
        ...(type === 'global' ? { assetType } : {}),
        ...(type === 'local' ? { assets } : {}),
        events,
        actions,
    });


export const updateWorkflow = (id, { name, description, cameras, signals, events, actions }) =>
    axiosInstance.put(`/workflows/${id}`, { name, description, cameras, signals, events, actions });

export const deleteWorkflow = (id) => axiosInstance.delete(`/workflows/${id}`);

// Asset APIs
export const getAssets = () => axiosInstance.get('/assets');

export const updateAssetStatus = ({ type, id, status }) =>
    axiosInstance.put('/assets/status', { type, id, status });

export const getTrafficCameras = ({ searchTerm, page, limit }) =>
    axiosInstance.get('/traffic-cameras', { params: { searchTerm, page, limit } });

export const getNearestTrafficCameras = ({ longitude, latitude, maxDistance, limit }) =>
    axiosInstance.get('/traffic-cameras/nearest', {
        params: { longitude, latitude, maxDistance, limit },
    });

export const getTrafficCameraById = (id) =>
    axiosInstance.get(`/traffic-cameras/${id}`);

// Traffic Signal APIs
export const getTrafficSignals = ({ searchTerm, page, limit }) =>
    axiosInstance.get('/traffic-signals', { params: { searchTerm, page, limit } });

export const getNearestTrafficSignals = ({ longitude, latitude, maxDistance, limit }) =>
    axiosInstance.get('/traffic-signals/nearest', {
        params: { longitude, latitude, maxDistance, limit },
    });

export const getTrafficSignalsById = (id) =>
    axiosInstance.get(`/traffic-signals/${id}`);

// Speed Detector APIs
export const getSpeedDetectors = ({ search, page, limit }) =>
    axiosInstance.get('/speed-detectors', { params: { search, page, limit } });

export const updateSpeedDetector = ({ id, status }) =>
    axiosInstance.put(`/speed-detectors/${id}`, { status });

export const getSpeedDetectorById = (id) =>
    axiosInstance.get(`/speed-detectors/${id}`);

// Traffic Message Board APIs
export const getTrafficMessageBoards = ({ search, page, limit }) =>
    axiosInstance.get('/traffic-message-boards', { params: { search, page, limit } });

export const getNearestTrafficMessageBoards = ({ longitude, latitude, maxDistance, page, limit }) =>
    axiosInstance.get('/traffic-message-boards/nearest', {
        params: { longitude, latitude, maxDistance, page, limit },
    });

export const updateTrafficMessageBoard = ({ id, status }) =>
    axiosInstance.put(`/traffic-message-boards/${id}`, { status });

export const getTrafficMessageBoardById = (id) =>
    axiosInstance.get(`/traffic-message-boards/${id}`);

export const getUsers = ({ page = 1, limit = 10 }) =>
    axiosInstance.get('/users', { params: { page, limit } });

// Create a new user
export const createUser = ({
    username,
    email,
    password,
    roles,
    organization,
    firstName,
    lastName,
    phone,
    address,
    status = 'active',
}) =>
    axiosInstance.post('/users', {
        username,
        email,
        password,
        roles,
        organization,
        firstName,
        lastName,
        phone,
        address,
        status,
    });

// Get a user by ID
export const getUserById = (userId) =>
    axiosInstance.get(`/users/${userId}`);

// Update an existing user
export const updateUser = (userId, updateData) =>
    axiosInstance.put(`/users/${userId}`, updateData);


export const getRoles = ({ page = 1, limit = 10 }) =>
    axiosInstance.get('/roles', { params: { page, limit } });

export const createRole = ({ name, permissions }) =>
    axiosInstance.post('/roles', { name, permissions });

export const getOrganizations = ({ page = 1, limit = 10 }) =>
    axiosInstance.get('/organizations', { params: { page, limit } });

export const getOrganizationById = (id) =>
    axiosInstance.get(`/organizations/${id}`);

export const updateOrganization = (id, updateData) =>
    axiosInstance.put(`/organizations/${id}`, updateData);

export const createOrganization = ({ name, description, contactEmail, contactPhone, address, industry }) =>
    axiosInstance.post('/organizations', { name, description, contactEmail, contactPhone, address, industry });


// Auth APIs
export const login = ({ email, password }) =>
    axiosInstance.post('/login', { email, password });

export const verifyToken = ( token ) =>
    axiosInstance.post('/verify-token', { token });

export const switchApp = ({ userId, appId }) =>
    axiosInstance.post('/switch-app', { userId, appId });


export const getIOTSensors = () =>
    axiosInstance.get('/iot-sensors');

export const getIOTDetections = () =>
    axiosInstance.get('/iot-detections');


// Get all Apps
export const getAllApps = () => axiosInstance.get("/apps");

// Get a single App by ID
export const getAppById = (appId) => axiosInstance.get(`/apps/${appId}`);

// Create a new App
export const createApp = (appData) => axiosInstance.post("/apps", appData);

// Delete an App by ID
export const deleteAppById = (appId) => axiosInstance.delete(`/apps/${appId}`);

export const updateAppById = (appId, appData) => axiosInstance.put(`/apps/${appId}`, appData);


/**
 * Create a new entity
 * @param {Object} entityData - The data for the new entity
 * @returns {Promise} - Axios promise for the POST request
 */
export const createEntity = (entityData) => 
    axiosInstance.post('/entities', entityData);
  
  /**
   * Get all entities with optional pagination
   * @param {Object} params - Query parameters (e.g., page, limit, appId)
   * @returns {Promise} - Axios promise for the GET request
   */
  export const getAllEntities = (params = {}) => 
    axiosInstance.get('/entities', { params });
  
  /**
   * Get an entity by ID
   * @param {string} entityId - The ID of the entity to retrieve
   * @returns {Promise} - Axios promise for the GET request
   */
  export const getEntityById = (entityId) => 
    axiosInstance.get(`/entities/${entityId}`);


export const getSensorDataById = async (sensorId, { page = 1, limit = 20 } = {}) => {
    try {
        const response = await axiosInstance.get(`/iot-sensor-data/${sensorId}`, {
            params: {
                page,
                limit,
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};
  
  
  /**
   * Update an entity by ID
   * @param {string} entityId - The ID of the entity to update
   * @param {Object} entityData - The updated data for the entity
   * @returns {Promise} - Axios promise for the PUT request
   */
  export const updateEntityById = (entityId, entityData) => 
    axiosInstance.put(`/entities/${entityId}`, entityData);
  
  /**
   * Delete an entity by ID
   * @param {string} entityId - The ID of the entity to delete
   * @returns {Promise} - Axios promise for the DELETE request
   */
  export const deleteEntityById = (entityId) => 
    axiosInstance.delete(`/entities/${entityId}`);
  
  /**
   * Find entities near a specific location
   * @param {Object} params - Query parameters (longitude, latitude, maxDistance, page, limit)
   * @returns {Promise} - Axios promise for the GET request
   */
  export const findEntitiesNear = (params = {}) => 
    axiosInstance.get('/entities/near', { params });

  export const getEntitiesByAppId = (appId, params = {}) => 
    axiosInstance.get(`/entities/search`, { params: { ...params, appId } });



  export const getAllTriggers = ( params ={}) => 
    axiosInstance.get(`/triggers`, { params });

  export const getTriggerById = (triggerId) =>
    axiosInstance.get(`/triggers/${triggerId}`);

  export const createTrigger = (triggerData) =>
    axiosInstance.post(`/triggers`, triggerData);

  export const editTrigger = (triggerId, triggerData) =>
    axiosInstance.put(`/triggers/${triggerId}`, triggerData);

  export const deleteTrigger = (triggerId) =>
    axiosInstance.delete(`/triggers/${triggerId}`);


  export const getAllMonitors = ( params ={}) => 
    axiosInstance.get(`/monitors`, { params });

  export const getMonitorById = (monitorId) =>
    axiosInstance.get(`/monitors/${monitorId}`);

  export const createMonitor = (monitorData) =>
    axiosInstance.post(`/monitors`, monitorData);

  export const editMonitor = (monitorId, monitorData) =>
    axiosInstance.put(`/monitors/${monitorId}`, monitorData);

  export const deleteMonitor = (monitorId) =>
    axiosInstance.delete(`/monitors/${monitorId}`);

// In api.jsx
export const chatWithGPT = (messages) =>
    axiosInstance.post('/chat', { messages });

export const queryCrashData = (userMessage, crashData) =>
    axiosInstance.post('/chat/querycrashdata', { userMessage, crashData });

export const chatWithData = (userMessage, data) =>
    axiosInstance.post('/chat/chatwithdata', { userMessage, data });
export const gptChatWithData = (userMessage, data) =>
    axiosInstance.post('/chat/gptchatwithdata', { userMessage, data });

export const queryProductChat = (userMessage) =>
    chatAxiosInstance.post('/product/answer-query', { userMessage });

export const getDetectionBySensors = (params) =>
    axiosInstance.post('/detectionDef', params);

export const createTriggerAction = (data) => axiosInstance.post(`/trigger-actions`, data);
export const getTriggerActions = () => axiosInstance.get(`/trigger-actions`);
export const deleteTriggerAction = (id) => axiosInstance.delete(`/trigger-actions/${id}`);

export const getAuditActions = ( params ={}) => 
    axiosInstance.get(`/audit`, { params });

export const getEntityIncidents = (params = {}) => 
    axiosInstance.get(`/entity-incidents`, { params });
export const getEntityIncidentById = (id,params = {}) => 
    axiosInstance.get(`/entity-incidents/${id}`, { params });

export const getEntityTriggers = (entityTypeId, id) =>
        axiosInstance.get(`/triggers/entity/${entityTypeId}/${id}`);



export const getAppSnapshot = ( params ={}) => 
    axiosInstance.get(`/snapshot`, { params });

export const refreshAppSnapshot = ( params ={}) => 
    axiosInstance.get(`/snapshot/refresh`, { params });

export const getActionTypes = () => axiosInstance.get(`/actiontype`);

export const getAllIcons = () => axiosInstance.get(`/icon`);

export const getAllAIAgents = () => axiosInstance.get(`/ai-agents`);

export const createAIAgent = (data) => axiosInstance.post(`/ai-agents`, data);

export const getAIAgentTemplates = (agentId) => axiosInstance.get(`/ai-agents/getTemplates`);

export const getAIAgentById = (agentId) => axiosInstance.get(`/ai-agents/${agentId}`);


export const updateAIAgent = (agentId, agentData) => axiosInstance.put(`/ai-agents/${agentId}`, agentData);

export const getAIDocuments = () => axiosInstance.get(`/ai-document`);

export const addAIDocument = (data) => axiosInstance.post(`/ai-agents/documents`, data);

export const addMap = (data) => axiosInstance.post(`/maps`, data);

export const getMaps = () => axiosInstance.get(`/maps`);

export const getMapById = (mapId) => axiosInstance.get(`/maps/${mapId}`);

export const updateMap = (mapId, data) => axiosInstance.put(`/maps/${mapId}`, data);

export const deleteMap = (mapId) => axiosInstance.delete(`/maps/${mapId}`);

export const uploadAIDocument = (formData) =>
    axiosUploadInstance.post("/ai-document/upload", formData);

export const uploadFileToStorage = (formData) =>
    axiosUploadInstance.post("/storage/upload", formData);

export const deleteFileFromStorage = (folderName,fileName) =>
    axiosUploadInstance.delete("/storage/delete", {folderName,fileName});

export const deleteMultipleFilesFromStorage = (folderName,fileNames) =>
    axiosUploadInstance.delete("/storage/delete-multiple", {folderName,fileNames});

export const chatWithAgent = (agentId, messages) => chatAxiosInstance.post(`/agent/${agentId}`, { userMessage : messages });

// Agent Marketplace APIs
export const getAllAgents = (params = {}) => 
    axiosInstance.get('/agent-marketplace', { params });

export const getAgentById = (agentId) => 
    axiosInstance.get(`/agent-marketplace/${agentId}`);

export const getFeaturedAgents = () => 
    axiosInstance.get('/agent-marketplace/featured');

export const getAgentCategories = () => 
    axiosInstance.get('/agent-marketplace/categories');

export const getAgentsByCategory = (category, params = {}) => 
    axiosInstance.get(`/agent-marketplace/category/${category}`, { params });

export const createAgent = (agentData) => 
    axiosInstance.post('/agent-marketplace', agentData);

export const updateAgent = (agentId, agentData) => 
    axiosInstance.put(`/agent-marketplace/${agentId}`, agentData);

export const deleteAgent = (agentId) => 
    axiosInstance.delete(`/agent-marketplace/${agentId}`);

export const populateAgentsData = () => 
    axiosInstance.post('/agent-marketplace/populate');

// Agent Workforce APIs
export const hireAgent = (agentData) => 
    axiosInstance.post('/agent-workforce/hire', agentData);

export const getHiredAgents = (appId, params = {}) => 
    axiosInstance.get('/agent-workforce', { params: { appId, ...params } });

export const getHiredAgentById = (agentId, appId) =>
    axiosInstance.get(`/agent-workforce/${agentId}`, { params: { appId } });

export const onboardAgent = (agentId, onboardingData, appId) =>
    axiosInstance.post(`/agent-workforce/${agentId}/onboard`, onboardingData, { params: { appId } });

export const updateHiredAgent = (agentId, agentData, appId) =>
    axiosInstance.put(`/agent-workforce/${agentId}`, agentData, { params: { appId } });

export const offboardAgent = (agentId, offboardingData, appId) =>
    axiosInstance.post(`/agent-workforce/${agentId}/offboard`, offboardingData, { params: { appId } });

export const getAgentPerformance = (agentId, appId) =>
    axiosInstance.get(`/agent-workforce/${agentId}/performance`, { params: { appId } });

export const updateAgentPerformance = (agentId, performanceData, appId) => 
    axiosInstance.put(`/agent-workforce/${agentId}/performance`, performanceData, { params: { appId } });

export const getAgentByEmail = (emailAddress) => 
    axiosInstance.get(`/agent-workforce/email/${emailAddress}`);

// Agent Chat API
export const chatWithAgentWorkforce = (agentId, messages, appId, conversationId = null) =>
    axiosInstance.post(`/agent-workforce/${agentId}/chat`, { 
      messages, 
      ...(conversationId && { conversationId }) 
    }, { params: { appId } });

// Agent Task APIs
export const createAgentTask = (taskData, appId) => 
    axiosInstance.post('/agent-tasks', taskData, { params: { appId } });

export const getTasksByAgent = (agentWorkforceId, appId, params = {}) => 
    axiosInstance.get(`/agent-tasks/agent/${agentWorkforceId}`, { params: { appId, ...params } });

export const getTasksByApp = (appId, params = {}) => 
    axiosInstance.get(`/agent-tasks/app/${appId}`, { params });

export const getAgentTaskById = (taskId, appId) => 
    axiosInstance.get(`/agent-tasks/${taskId}`, { params: { appId } });

export const updateAgentTask = (taskId, taskData, appId) => 
    axiosInstance.put(`/agent-tasks/${taskId}`, taskData, { params: { appId } });

export const deleteAgentTask = (taskId, appId) => 
    axiosInstance.delete(`/agent-tasks/${taskId}`, { params: { appId } });

export const executeAgentTask = (taskId, appId) => 
    axiosInstance.post(`/agent-tasks/${taskId}/execute`, {}, { params: { appId } });

export const getTaskExecutionHistory = (taskId, appId, params = {}) => 
    axiosInstance.get(`/agent-tasks/${taskId}/history`, { params: { appId, ...params } });

// Chat Conversation APIs
export const getChatConversations = (agentId, appId) =>
    axiosInstance.get(`/agent-workforce/${agentId}/conversations`, { params: { appId } });

export const getConversation = (conversationId) =>
    axiosInstance.get(`/agent-workforce/conversations/${conversationId}`);

export const createConversation = (conversationData, appId) =>
    axiosInstance.post('/agent-workforce/conversations', conversationData, { params: { appId } });

export const addMessageToConversation = (conversationId, messageData) =>
    axiosInstance.post(`/agent-workforce/conversations/${conversationId}/messages`, messageData);

export const updateConversationTitle = (conversationId, title) =>
    axiosInstance.put(`/agent-workforce/conversations/${conversationId}/title`, { title });

export const archiveConversation = (conversationId) =>
    axiosInstance.post(`/agent-workforce/conversations/${conversationId}/archive`);

export const deleteConversation = (conversationId) =>
    axiosInstance.delete(`/agent-workforce/conversations/${conversationId}`);

// Task-specific Chat Conversation APIs
export const chatWithTask = (taskId, messages, appId) =>
    axiosInstance.post(`/agent-workforce/tasks/${taskId}/chat`, { messages }, { params: { appId } });

export const getTaskConversations = (taskId) =>
    axiosInstance.get(`/agent-workforce/tasks/${taskId}/conversations`);

export const getTaskConversation = (conversationId) =>
    axiosInstance.get(`/agent-workforce/task-conversations/${conversationId}`);

export const createTaskConversation = (conversationData, appId) =>
    axiosInstance.post('/agent-workforce/task-conversations', conversationData, { params: { appId } });

export const addMessageToTaskConversation = (conversationId, messageData) =>
    axiosInstance.post(`/agent-workforce/task-conversations/${conversationId}/messages`, messageData);

export const updateTaskConversationTitle = (conversationId, title) =>
    axiosInstance.put(`/agent-workforce/task-conversations/${conversationId}/title`, { title });

export const archiveTaskConversation = (conversationId) =>
    axiosInstance.post(`/agent-workforce/task-conversations/${conversationId}/archive`);

export const deleteTaskConversation = (conversationId) =>
    axiosInstance.delete(`/agent-workforce/task-conversations/${conversationId}`);

// VLM Sensor API functions
/**
 * Create VLM sensor configuration
 * @param {Object} configData - VLM configuration data
 * @returns {Promise} - Axios promise for the POST request
 */
export const createVLMConfig = (configData) =>
    axiosInstance.post('/vlm-sensors/config', configData);

/**
 * Get VLM sensor configuration by entity sensor ID
 * @param {string} entitySensorId - The entity sensor ID
 * @returns {Promise} - Axios promise for the GET request
 */
export const getVLMConfig = (entitySensorId) =>
    axiosInstance.get(`/vlm-sensors/config/${entitySensorId}`);

/**
 * Update VLM sensor configuration (reconfigure)
 * @param {string} entitySensorId - The entity sensor ID
 * @param {Object} configData - Updated configuration data
 * @returns {Promise} - Axios promise for the PUT request
 */
export const updateVLMConfig = (entitySensorId, configData) =>
    axiosInstance.put(`/vlm-sensors/config/${entitySensorId}`, configData);

/**
 * Update VLM training progress
 * @param {string} entitySensorId - The entity sensor ID
 * @param {Object} progressData - Training progress data
 * @returns {Promise} - Axios promise for the PUT request
 */
export const updateVLMTrainingProgress = (entitySensorId, progressData) =>
    axiosInstance.put(`/vlm-sensors/config/${entitySensorId}/training-progress`, progressData);

/**
 * Deploy VLM model
 * @param {string} entitySensorId - The entity sensor ID
 * @param {Object} deploymentData - Deployment data
 * @returns {Promise} - Axios promise for the POST request
 */
export const deployVLMModel = (entitySensorId, deploymentData) =>
    axiosInstance.post(`/vlm-sensors/config/${entitySensorId}/deploy`, deploymentData);

/**
 * Record VLM event detection
 * @param {string} entitySensorId - The entity sensor ID
 * @param {Object} eventData - Event data
 * @returns {Promise} - Axios promise for the POST request
 */
export const recordVLMEvent = (entitySensorId, eventData) =>
    axiosInstance.post(`/vlm-sensors/config/${entitySensorId}/event`, eventData);

/**
 * Get VLM configurations by app ID
 * @param {string} appId - The app ID
 * @param {Object} params - Query parameters
 * @returns {Promise} - Axios promise for the GET request
 */
export const getVLMConfigsByApp = (appId, params = {}) =>
    axiosInstance.get(`/vlm-sensors/app/${appId}/configs`, { params });

/**
 * Get VLM events/detections
 * @param {string} entitySensorId - The entity sensor ID
 * @param {Object} params - Query parameters (page, limit, startDate, endDate)
 * @returns {Promise} - Axios promise for the GET request
 */
export const getVLMEvents = (entitySensorId, params = {}) =>
    axiosInstance.get(`/vlm-sensors/config/${entitySensorId}/events`, { params });

/**
 * Add a new prompt to existing VLM configuration
 * @param {string} entitySensorId - The entity sensor ID
 * @param {Object} promptData - The prompt configuration data
 * @returns {Promise} - Axios promise for the POST request
 */
export const addVLMPrompt = (entitySensorId, promptData) =>
    axiosInstance.post(`/vlm-sensors/config/${entitySensorId}/prompts`, promptData);

/**
 * Remove a prompt from existing VLM configuration
 * @param {string} entitySensorId - The entity sensor ID
 * @param {number} promptIndex - The index of the prompt to remove
 * @param {Object} userData - User data (userId)
 * @returns {Promise} - Axios promise for the DELETE request
 */
export const removeVLMPrompt = (entitySensorId, promptIndex, userData = {}) =>
    axiosInstance.delete(`/vlm-sensors/config/${entitySensorId}/prompts/${promptIndex}`, { data: userData });

/**
 * Delete VLM configuration
 * @param {string} entitySensorId - The entity sensor ID
 * @returns {Promise} - Axios promise for the DELETE request
 */
export const deleteVLMConfig = (entitySensorId) =>
    axiosInstance.delete(`/vlm-sensors/config/${entitySensorId}`);